import { Ga4EventType, ga4Info } from '../../util/GA4/index'
import { leaveGameToLobby } from '../../domain/leaveGame/leaveGameUtil'
import { ButtonProps } from '../menu/interface/ButtonProps'
import { Button } from '../../UI/Button'

export const LeaveGameButtonV2 = (props: ButtonProps) => {
  return (
    <Button
      name="Leave Game Button"
      defaultView="leave_game_normal_v2"
      hoverView="leave_game_hover_v2"
      pressedView="leave_game_click_v2"
      disabledView="leave_game_unable_v2"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPress={() => {
        leaveGameToLobby()
        ga4Info.addEvent(Ga4EventType.menu_lobby)
      }}
    />
  )
}
